<template>
  <section>
    <div class="box">
      <h1 class="subtitle is-5">Autoridad Certificante</h1>
      <h1 class="title is-1">Certificados</h1>
      <div class="content">
        <p>Certificados de la organización.</p>
      </div>
    </div>
    <Filtros @set-query="setQuery" @refresh="refresh"/>
    <Listado ref="listado" />
  </section>
</template>
<script>
import Filtros from '@/views/certificados/oficial-registro/Filtros'
import Listado from '@/views/certificados/oficial-registro/Listado'
export default {
  components: {
    Filtros,
    Listado
  },
  methods: {
    setQuery: function (query) {
      this.$refs.listado.setQuery(query)
    },
    refresh: function () {
      this.$refs.listado.refresh()
    }
  }
}
</script>
